import background from "../../assets/images/background.png";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import { DASHBOARD_ROUTE, HOME_ROUTE, LOGIN_ROUTE } from "../../routes";
import { Link } from "react-router-dom";

const FailPage = ({history}) => {
    return ( 
        <div id="fail-page" style={{
            backgroundImage: `url(${background})`,
            minHeight: "100vh",
        }}>
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                </div>
                <h1 className="text-center text-light mt-5">Oops! Sorry, looks like something went wrong…</h1>
                <h5 className="text-center text-light mt-5">While we fix it, you can go to…</h5>
                <div className="text-center mt-5 d-md-flex d-sm-block justify-content-center">
                    <Link className="d-block text-center text-light m-4" to={LOGIN_ROUTE}>
                        <button style={{height:"3rem"}} className="btn btn-outline-light w-100 rounded-pill px-5 text-btn">Go to Login</button>
                    </Link>
                    <Link className="d-block text-center text-light m-4" to={HOME_ROUTE}>
                        <button style={{height:"3rem"}} className="btn btn-outline-light w-100 rounded-pill px-5 text-btn">Go to Home</button>
                    </Link>
                </div>
            </div>
        </div> 
    );
}
 
export default FailPage;